export default __webpack_public_path__ + "static/media/warning_icon.98dc0b55.svg";